import { render } from "./ReceiptsList.vue?vue&type=template&id=1efa612e"
import script from "./ReceiptsList.vue?vue&type=script&lang=js"
export * from "./ReceiptsList.vue?vue&type=script&lang=js"

import "./ReceiptsList.vue?vue&type=style&index=0&id=1efa612e&lang=scss"
script.render = render

export default script